import SImage from './SImage'
import SArticleCate from './SArticleCate'
import SGoods from './SGoods'
import SGoodsCate from './SGoodsCate'
import SLink from './SLink'
import SLink2 from './SLink2'
import SHotZone from './SHotZone'
import SCoupon from './SCoupon'
import SInput from './SInput.vue'
import SLive1 from './SLive1.vue'
import SMarks from './SMarks.vue'
import SMarksup from './SMarksup.vue'
import SCouponpack from './SCouponpack.vue'
import SstoreCate from './SstoreCate.vue'

export { SImage, SArticleCate, SGoods ,SstoreCate,SCouponpack, SGoodsCate, SLink, SLink2, SHotZone, SCoupon ,SLive1, SInput,SMarks,SMarksup}
